import { CommonModule } from '@angular/common';
import { Component, NgModule, Input, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { DxFormModule } from 'devextreme-angular/ui/form';
import { DxLoadIndicatorModule } from 'devextreme-angular/ui/load-indicator';
import notify from 'devextreme/ui/notify';
import { AuthService, IResponse } from 'src/app/services';

const notificationText = 'Elküldtünk egy linket a jelszó visszaállításához. Ellenőrizze a postaládáját.';

@Component({
	selector: 'reset-password-form',
	templateUrl: './reset-password-form.component.html',
	styleUrls: ['./reset-password-form.component.scss'],
})
export class ResetPasswordFormComponent implements OnInit {
	@Input() signInLink = '/auth/login';

	@Input() buttonLink = '/auth/login';

	defaultAuthData: IResponse;

	loading = false;

	formData: any = {};

	constructor(private authService: AuthService, private router: Router) { }

	async onSubmit(e: Event) {
		e.preventDefault();
		const { email } = this.formData;
		this.loading = true;

		const result = await this.authService.resetPassword(email);
		this.loading = false;

		if (result.isOk) {
			this.router.navigate([this.buttonLink]);
			notify(notificationText, 'success', 2500);
		} else {
			notify(result.message, 'error', 2000);
		}
	}

	async ngOnInit(): Promise<void> {
		this.defaultAuthData = await this.authService.getUser();
	}
}
@NgModule({
	imports: [
		CommonModule,
		RouterModule,
		DxFormModule,
		DxLoadIndicatorModule,
	],
	declarations: [ResetPasswordFormComponent],
	exports: [ResetPasswordFormComponent],
})
export class ResetPasswordFormModule { }
